
export const PAID = "Paid";
export const TO_PAY = "To Pay";
export const FOC = "FOC";
export const COD = "COD";
export const ON_ACCOUNT = "On-Account";
export const PAID_MANUAL = "PAID Manual";
export const TO_PAY_MANUAL = "TO PAY Manual";
export const SELF = "Self";
export const TO_PAY_DDDV = "To Pay DDDV";
export const ONACCOUNT_MANUAL = "On-Account Manual";
export const ALL = "ALL";

export const bkgAll = `All`
export const bkgPAID = `PAID`
export const bkgTOPAY = `TOPAY`
export const bkgFOC = `FOC`
export const bkgCOD = `COD`
export const bkgOnAcc = `OnAcc`
export const bkgSelf = `Self`
export const bkgToPayDDDV = `ToPayDDDV`

//payment id association with payment names;
export const paytypes = {
  PAID: 1,
  TO_PAY: 2,
  FOC: 3,
  COD: 4,
  ON_ACCOUNT: 5,
  PAID_MANUAL: 6,
  TO_PAY_MANUAL: 7,
  SELF: 8,
  TO_PAY_DDDV: 9,
  ONACCOUNT_MANUAL: 10,
}
export const TOPAY_COD_RULE = {
  [paytypes.TO_PAY]: 'COD',
  [paytypes.TO_PAY_MANUAL]: 'COD Manual',
  [paytypes.TO_PAY_DDDV]: 'COD DDDV',
};
export const TOPAY_COD_RULE2 = {
  'TOPAY': 'COD',
  'TOPAY(MANUAL)': 'COD Manual',
  'TOPAY(DDDV)': 'COD DDDV',
}
export const toPayIds = [paytypes.TO_PAY,paytypes.TO_PAY_MANUAL,paytypes.TO_PAY_DDDV,paytypes.COD]
//keys 
export const IsAll= `IsAll`
export const IsPaid= `IsPaid`
export const IsToPay= `IsToPay`
export const IsFOC= `IsFOC`
export const IsCOD= `IsCOD`
export const OnAcc= `OnAcc`
export const IsManual = `IsManual`
export const IsOnAccount = `IsOnAccount`

export const paymentModes = [
    { typeId: 1, type: PAID, name: "Paid", f: IsPaid, b: bkgPAID, isEnabled: true,isActive2:"Ispaid",isActive:"IsPaid",roleRightsId:"PAID" },
    { typeId: 2, type: TO_PAY, name: "To Pay", f: IsToPay, b: bkgTOPAY, isEnabled: true ,isActive:"IsTopay",isActive2:"IsToPay",roleRightsId:"TOPAY"},
    { typeId: 3, type: FOC, name: "FOC", f: IsFOC, b: bkgFOC, isEnabled: true ,isActive2:"IsFOC",isActive:"IsFOC",roleRightsId:"FOC"},
    { typeId: 4, type: COD, name: "COD", f: IsCOD, b: bkgCOD, isEnabled: true ,isActive2:"IsCOD",isActive:"IsCOD",roleRightsId:"COD"},
    { typeId: 5, type: ON_ACCOUNT, name: "On Account", f: OnAcc, b: bkgOnAcc, isEnabled: true ,isActive2:"IsOnAcc",isActive:"OnAcc",roleRightsId:"OnAcc"},
    { typeId: 6, type: PAID_MANUAL, name: "Paid (Manual)", f: false, b: false, isEnabled: true ,isActive2:"IsPaidMan",isActive:"IsPaidMan",roleRightsId:"PaidMan"},
    { typeId: 7, type: TO_PAY_MANUAL, name: "To Pay (Manual)", f: false, b: false, isEnabled: true ,isActive2:"IsTopayMan",isActive:"IsTopayMan",roleRightsId:"TopayMan"},
    { typeId: 8, type: SELF, name: "Self", f: false, b: bkgSelf , isEnabled: true ,isActive2:"IsSelf",isActive:"IsSelf",roleRightsId:"Self"},
    { typeId: 9, type: TO_PAY_DDDV, name: "To Pay DDDV", f: false, b: bkgToPayDDDV, isEnabled: false ,isActive2:"IsDDDV",isActive:"IsDDDV",roleRightsId:"ToPayDDDV"},
    { typeId: 10, type: ONACCOUNT_MANUAL, name: "On Account (Manual)", f: false, b: false, isEnabled: true ,isActive2:"IsOnAccMan",isActive:"IsOnAccMan",roleRightsId:"OnAccMan"}
];
export const modeAllPayments = { typeId: 0, type: ALL, name: "All", f: 'none', b: 'none', isEnabled: true }
export const paymentModesWithAll=[modeAllPayments,...paymentModes];
export const paymentModeswithDDDV = [modeAllPayments,...paymentModes,{ typeId: 9, type: TO_PAY_DDDV, name: "To Pay DDDV", f: false, b: bkgToPayDDDV, isEnabled: false,isActive:"IsDDDV",isActive2:"Isdddv" }];

export const getPaymentTypeId = (paymentType) => paymentModesWithAll.find(({ type }) => type == paymentType).typeId;
export const getPaymentType = (paymentTypeId) => paymentModesWithAll.find(({ typeId }) => typeId == paymentTypeId).type;
export const getPaymentTypeName = (paymentTypeId) => paymentModesWithAll.find(({ typeId }) => typeId == paymentTypeId)?.name;
// export const getPaymentTypeNameAll = (paymentTypeId,UseToPayAsCOD) => paymentModeswithDDDV.find(({ typeId }) => typeId == paymentTypeId)?.name;
export const getPaymentTypeNameAll = (paymentTypeId, UseToPayAsCOD) => {
  const payment = paymentModeswithDDDV.find(({ typeId }) => typeId == paymentTypeId);
  if (!payment) return '';
  if (UseToPayAsCOD === 1) {
    switch (paymentTypeId) {
      case '2': return 'COD';
      case '7': return 'COD(MANUAL)';
      case '9': return 'COD(DDDV)';
      default: return payment.name;
    }
  }
  return payment.name;
};

export const getPaymentMode = (paymentTypeId) => paymentModesWithAll.find(({ typeId }) => typeId == paymentTypeId);
export const getPaymentModeV2 = (paymentTypeId) => {
    const paymentMode = paymentModesWithAll.find(({ typeId }) => typeId === paymentTypeId);
    if (!paymentMode) return null;
    if (paymentMode.typeId === 2) {
        return { ...paymentMode, name: "COD" };
    }else if(paymentMode.typeId === 7){
      return { ...paymentMode, name: "COD MANUAL" };
    }else if(paymentMode.typeId === 9){
      return { ...paymentMode, name: "COD DDDV" };
    }
    return paymentMode;
};
export const AllPaymentList=[ALL,PAID,TO_PAY,FOC,COD,ON_ACCOUNT,PAID_MANUAL,TO_PAY_MANUAL,SELF,TO_PAY_DDDV,ONACCOUNT_MANUAL]
// console.log(getPaymentTypeId(PAID))
// console.log(getPaymentTypeName(5))
// console.log(getPaymentType(6))
// console.log(getPaymentMode(1))